<h4 class="fw-bold">
    {{ "rules_management.add_ruleset" | translate }}
    <span class="fw-light mx-1">
        @if (displayLabel) {
            - {{ displayLabel }}
        }
    </span>
</h4>

<form class="col-12 my-2" [formGroup]="integrityRulesForm">
    <div class="bg-card shadow-md rounded p-2 mb-3">
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameAE' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('nameAE')"
                    formControlName="nameAE"
                    controlName="nameAE"
                ></adaa-form-input>
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameEN' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('nameEN')"
                    formControlName="nameEN"
                    controlName="nameEN"
                ></adaa-form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionAE' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dscAE')"
                    formControlName="dscAE"
                    controlName="dscAE"
                    [isTextArea]="true"
                ></adaa-form-input>
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionEN' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('dscEN')"
                    formControlName="dscEN"
                    controlName="dscEN"
                    [isTextArea]="true"
                ></adaa-form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <adaa-form-dropdown
                    formControlName="type"
                    controlName="type"
                    [options]="rulesetTypes()"
                    [label]="'rules_management.ruleset_type' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('type')"
                    [clearable]="true"
                ></adaa-form-dropdown>
            </div>
            <div class="col-4">
                <adaa-form-dropdown
                    formControlName="severity"
                    controlName="severity"
                    [options]="rulesetSeverities()"
                    [label]="'rules_management.ruleset_severity' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('severity')"
                    [clearable]="true"
                ></adaa-form-dropdown>
            </div>
            <div class="col-4">
                <adaa-form-dropdown
                    formControlName="combinationMode"
                    controlName="combinationMode"
                    [options]="activationTypes()"
                    [label]="'rules_management.ruleset_combination' | translate"
                    [setValidator]="formValidation()!"
                    [invalid]="checkInvalid('combinationMode')"
                    [clearable]="true"
                ></adaa-form-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-center">
                <adaa-form-checkbox
                    [label]="'rules_management.snooze' | translate"
                    [checkboxMode]="'yesNo'"
                    controlName="snooze"
                    formControlName="snooze"
                ></adaa-form-checkbox>
            </div>
        </div>
    </div>

    @if (integrityRulesForm.get("type")?.value !== null) {
        <div class="bg-card p-2 my-2" [class.invalid]="selectionInvalid()">
            @if (integrityRulesForm.get("type")?.value === Constants.CONSTANT_RULES_MANAGEMENT_CALENDAR_PROP) {
                <div class="row">
                    <div class="col-12">
                        <adaa-form-dropdown
                            formControlName="scope"
                            controlName="scope"
                            [options]="scopes()"
                            [label]="'rules_management.scope' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="checkInvalid('scope')"
                            [clearable]="true"
                        ></adaa-form-dropdown>
                    </div>
                </div>

                @if (integrityRulesForm.get("scope")?.value === Constants.CONSTANT_RULES_MANAGEMENT_SCOPE_ENTITY) {
                    <div class="my-3">
                        <adaa-form-two-way-select
                            [notSelectedLabel]="'rules_management.entities' | translate"
                            [selectedLabel]="'rules_management.selected_entities' | translate"
                            [options]="entityOptions()"
                            [setValidator]="formValidation()!"
                            formControlName="affectedEntities"
                            controlName="affectedEntities"
                        ></adaa-form-two-way-select>
                    </div>
                }

                <div class="my-2 p-2">
                    <h5 class="fw-bold text-center mt-2">{{ "rules_management.select_schedule" | translate }}</h5>
                    <div class="row d-flex justify-content-around my-4 mx-2">
                        @for (period of periods(); track $index) {
                            <span
                                class="tab col-12 col-md-5 bg-secondary text-light text-center rounded-lg my-2 p-2 period"
                                [class.active]="period.isActive"
                                (click)="selectPeriod(period.value)"
                                >{{ period.text }}</span
                            >
                        }
                    </div>
                    <div class="row d-flex justify-content-evenly m-2">
                        @for (day of days(); track $index) {
                            <span
                                class="tab col-6 col-md-2 bg-secondary text-light text-center rounded-lg my-2 p-2 day row-gap"
                                [class.active]="day.isActive"
                                (click)="selectDay(day.value)"
                                >{{ day.text }}</span
                            >
                        }
                    </div>
                </div>

                <div class="my-2">
                    <adaa-form-input-time
                        controlName="scheduleTime"
                        formControlName="scheduleTime"
                        [label]="'rules_management.start_hour' | translate"
                        [invalid]="checkInvalid('scheduleTime')"
                        [setValidator]="formValidation()!"
                    />
                </div>
            }
            @if (integrityRulesForm.get("type")?.value === Constants.CONSTANT_RULES_MANAGEMENT_TRIGGER_PROP) {
                <div class="d-flex mx-2 my-3 align-items-center">
                    <div class="flex-fill me-2">
                        <adaa-form-dropdown
                            formControlName="triggerConfigId"
                            controlName="triggerConfigId"
                            [options]="objectTypes()"
                            [label]="'rules_management.available_objects' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="checkInvalid('triggerConfigId')"
                            [clearable]="true"
                        ></adaa-form-dropdown>
                    </div>

                    <div class="flex-fill me-2">
                        <adaa-form-dropdown
                            formControlName="actionId"
                            controlName="actionId"
                            [options]="actions()"
                            [label]="'rules_management.trigger_actions' | translate"
                            [setValidator]="formValidation()!"
                            [invalid]="checkInvalid('actionId')"
                            [clearable]="true"
                        ></adaa-form-dropdown>
                    </div>

                    <button class="btn btn-sm btn-secondary rounded-circle cursor-pointer action-btn" (click)="addTrigger()">
                        <i class="fa fa-plus"></i>
                    </button>
                </div>

                @for (trigger of filteredTriggers(); track $index) {
                    <div class="d-flex mx-2 my-3 align-items-center">
                        <span class="flex-fill bg-secondary text-white text-center rounded item p-1 me-2"> {{ trigger.object }} </span>
                        <span class="flex-fill bg-secondary text-white text-center rounded item p-1 me-2"> {{ trigger.action }} </span>
                        <button class="btn btn-sm btn-secondary rounded-circle cursor-pointer" (click)="removeTrigger(trigger)">
                            <i class="adaa-icon-delete"></i>
                        </button>
                    </div>
                }
            }
        </div>
    }
</form>

<div class="bg-card p-2 my-4" [class.invalid]="!filteredRules().length && submitted()">
    <adaa-data-table
        #adaaDataTable
        [titleHeader]="'rules_management.rules' | translate"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.RULES_MANAGEMENT_RULES"
        [itemTypeId]="Constants.CONSTANT_PERMISSIONS.RULES_MANAGEMENT"
        [isLocalData]="true"
        [localData]="filteredRules()"
        (actionClicked)="getAction($event)"
        (addNewClicked)="addNewRule()"
    ></adaa-data-table>
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [showSaveButton]="pageMode() !== PageMode.view"
        [saveButtonTitle]="'common.form.button.submit' | translate"
        [cancelButtonTitle]="pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)"
        (saveClicked)="submit()"
        (cancelClicked)="goBack()"
    ></adaa-form-action-buttons>
</div>

<adaa-add-rule-modal [ruleTypeOptions]="ruleTypes()" #addRule (ruleData)="saveRule($event)"></adaa-add-rule-modal>
